// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputb-container[data-v-32f7b9b0] {\n  display: flex;\n}\n.inputb-container .btn[data-v-32f7b9b0] {\n  width: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
